// extracted by mini-css-extract-plugin
export default {"container":"Po-z","ratingLayout":"Qo-z","ratingLabel":"Ro-z","nonInteractiveRatingLabel":"So-z"};